import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActivationRequestModal from './ActivationRequestModal';

interface Props {
  trialEndDate: string;
  activationRequested: boolean;
  vendorEmail: string;
}

export default function TrialCountdownWidget({ trialEndDate, activationRequested, vendorEmail }: Props) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const end = new Date(trialEndDate).getTime();
  const now = Date.now();
  const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24));

  const color =
    daysLeft <= 0
      ? 'bg-red-900/80 border-red-700 text-red-300'
      : daysLeft <= 3
      ? 'bg-orange-900/80 border-orange-700 text-orange-300'
      : 'bg-[#1a2035] border-white/10 text-gray-300';

  const label =
    daysLeft <= 0
      ? t('countdown.trialExpired')
      : daysLeft === 1
      ? t('countdown.trialEndsToday')
      : t('countdown.trialDaysLeft', { days: daysLeft });

  return (
    <>
      <div className={`fixed bottom-4 left-4 z-40 flex items-center gap-3 px-4 py-2.5 rounded-xl border backdrop-blur-sm shadow-lg text-sm ${color}`}>
        <span className="font-semibold whitespace-nowrap">{label}</span>
        {!activationRequested ? (
          <button
            onClick={() => setShowModal(true)}
            className="text-xs px-2.5 py-1 rounded-lg bg-violet-600 hover:bg-violet-500 text-white font-medium transition-colors whitespace-nowrap"
          >
            {t('countdown.requestActivation')}
          </button>
        ) : (
          <span className="text-xs opacity-70">{t('countdown.activationRequested')}</span>
        )}
      </div>

      {showModal && (
        <ActivationRequestModal
          vendorEmail={vendorEmail}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
